import { render, staticRenderFns } from "./AccountDrawer.vue?vue&type=template&id=2dcf9f07"
import script from "./AccountDrawer.vue?vue&type=script&lang=js"
export * from "./AccountDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports